export const ORDER_LABELS = {
  en_attente: "En attente",
  payee: "Payée",
  en_production: "En production",
  expediee: "Expédiée",
  livree: "Livrée",
  annulee: "Annulée",
};

export const QUOTE_LABELS = {
  nouveau: "Nouveau",
  en_cours: "En cours",
  devis_envoye: "Devis envoyé",
  accepte: "Accepté",
  refuse: "Refusé",
  termine: "Terminé",
};

export const STATUS_COLOR = {
  en_attente: "bg-gray-500/20 text-gray-300 border-gray-500/40",
  payee: "bg-[#0055FF]/20 text-[#5b8dff] border-[#0055FF]/40",
  en_production: "bg-[#E6007E]/20 text-[#ff5bb4] border-[#E6007E]/40",
  expediee: "bg-[#0055FF]/20 text-[#5b8dff] border-[#0055FF]/40",
  livree: "bg-green-500/20 text-green-300 border-green-500/40",
  annulee: "bg-red-500/20 text-red-300 border-red-500/40",
  nouveau: "bg-[#E6007E]/20 text-[#ff5bb4] border-[#E6007E]/40",
  en_cours: "bg-[#0055FF]/20 text-[#5b8dff] border-[#0055FF]/40",
  devis_envoye: "bg-[#0055FF]/20 text-[#5b8dff] border-[#0055FF]/40",
  accepte: "bg-green-500/20 text-green-300 border-green-500/40",
  refuse: "bg-red-500/20 text-red-300 border-red-500/40",
  termine: "bg-green-500/20 text-green-300 border-green-500/40",
};

export function StatusBadge({ status, type = "order" }) {
  const label = (type === "order" ? ORDER_LABELS : QUOTE_LABELS)[status] || status;
  return (
    <span className={`inline-block rounded-full border px-3 py-1 text-xs font-bold ${STATUS_COLOR[status] || "bg-gray-500/20 text-gray-300 border-gray-500/40"}`}>
      {label}
    </span>
  );
}

export function shortId(id) {
  return (id || "").slice(0, 8).toUpperCase();
}
